<form
  class="field-dialog__content__scroll p-24"
  fxLayout="column"
  name="form"
  [formGroup]="reallocateMaintenancesForm"
  fusePerfectScrollbar
>
  <div class="card" fxLayout="column">
    <div class="card__label" fxLayout="row">
      <label class="card-title">
        {{ 'MAINTENANCES.REALLOCATE_DIALOG.MAINTENANCE' | translate }}
      </label>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy" fxFlex="30" fxFlex.xs="100" class="pr-4">
        <mat-label>{{ 'MAINTENANCES.NUMBER' | translate }}</mat-label>
        <input matInput formControlName="number" disabled />
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex fxFlex.xs="100" class="pl-4">
        <mat-label>{{ 'MAINTENANCES.TYPES' | translate }}</mat-label>
        <input matInput formControlName="type" disabled />
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy" fxFlex="30" fxFlex.xs="100" class="pr-4">
        <mat-label>{{ 'MAINTENANCES.OPENED_DATE' | translate }}</mat-label>
        <input matInput [matDatepicker]="openedPicker" formControlName="openedDate" disabled />
        <mat-datepicker-toggle matSuffix [for]="openedPicker"></mat-datepicker-toggle>
        <mat-datepicker #openedPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="legacy" fxFlex="20" fxFlex.xs="100" class="px-4">
        <mat-label>{{ 'MAINTENANCES.OPENED_TIME' | translate }}</mat-label>
        <input matInput formControlName="openedTime" placeholder="__:__" mask="Hh:m0" disabled />
      </mat-form-field>

      <segments fxFlex="50" fxFlex.xs="100" class="pl-4" appearance="legacy" formControlName="segment" disabled>
      </segments>
    </div>
  </div>

  <schedule-suggestions [form]="reallocateMaintenancesForm"></schedule-suggestions>

  <div
    class="card"
    fxLayout="column"
    [ngClass]="{
      'company-reallocate-error-border': reallocateMaintenancesForm
        .get('newCompany')
        .hasError('companyReallocateDuplicated')
    }"
  >
    <div class="card__label" fxLayout="row">
      <label
        class="card-title"
        [ngClass]="{
          'company-reallocate-error-color': reallocateMaintenancesForm
            .get('newCompany')
            .hasError('companyReallocateDuplicated')
        }"
      >
        {{ 'MAINTENANCES.REALLOCATE_DIALOG.REALLOCATE' | translate }}
      </label>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <companies
        class="pr-4"
        appearance="legacy"
        disabled
        fxFlex="50"
        formControlName="company"
        [floatLabel]="true"
        floatLabelText="{{ 'MAINTENANCES.CURRENT_COMPANY' | translate }}"
      >
      </companies>
      <companies
        class="pl-4"
        appearance="legacy"
        required
        fxFlex="50"
        formControlName="newCompany"
        [floatLabel]="true"
        [preloadResults]="true"
        floatLabelText="{{ 'MAINTENANCES.REALLOCATE_TO' | translate }}"
        [compareWithCoords]="locationAddressCoords"
      >
      </companies>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="legacy" fxFlex="100">
        <textarea
          matInput
          matTextareaAutosize
          placeholder="{{ 'MAINTENANCES.RELOCATION_REASON' | translate }}"
          matAutosizeMinRows="2"
          matAutosizeMaxRows="3"
          formControlName="message"
          required
        >
        </textarea>
        <mat-error *ngIf="reallocateMaintenancesForm.get('message').hasError('required')">
          {{ 'MAINTENANCES.ERRORS.REASON_REQUIRED' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="center">
      <mat-error
        *ngIf="reallocateMaintenancesForm.get('newCompany').hasError('companyReallocateDuplicated')"
        class="custom-error"
      >
        {{ 'MAINTENANCES.ERRORS.COMPANY_REALLOCATE_DUPLICATED' | translate }}
      </mat-error>
    </div>
  </div>
</form>
